import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ProfileState {
  username: string;
}

const initialState: ProfileState = {
  username: ""
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    aaa: (state, action: PayloadAction<{ username: string }>) => {
      state.username = action.payload.username;
    }
  }
});

export const { aaa } = profileSlice.actions;
export default profileSlice.reducer;
